module.exports = __webpack_public_path__ + "static/media/LandingResearch.02594b40.png";